module.exports = __webpack_public_path__ + "img/service-bottom1.a3ec957b.png";